import React from "react";
import { NavLink } from "react-router-dom";
import "./BrandBar.css";

import logo from "../assets/wpark-logo-transparent.png";

export default function BrandBar() {
  return (
    <header className="brandBar">
      <div className="brandBar__inner">
        <NavLink to="/" className="brandBar__brand" aria-label="WPark Home">
          <img
            src={logo}
            alt=""
            className="brandBar__logo"
          />

          <span className="brandBar__name">
            WPARK
          </span>
        </NavLink>

        <span className="brandBar__divider" />

        <nav className="brandBar__nav" aria-label="Main navigation">
          <NavLink to="/team">
            Team
          </NavLink>

          <NavLink to="/advisors">
            Advisors
          </NavLink>
        </nav>

        <a
          href="https://calendly.com/jackychu-thewpark/jacky-coffee-session?month=2026-08"
          target="_blank"
          rel="noopener noreferrer"
          className="brandBar__cta"
        >
          Book a Call
        </a>
      </div>
    </header>
  );
}